import { AppTeamUtil } from '../../core/app-team-util';

export class MemberUploadLineErrorModel
{
    ColumnIndex!: number;
    Error!: string;

    constructor(json?: any)
    {
        if (json) Object.assign(this, json);
    }
}

export class MemberUploadError
{
    LineNumber!: number;
    InputLine!: string;
    Errors: MemberUploadLineErrorModel[] = [];

    private columnData: string[] = [];

    constructor(json?: any)
    {
        if (json) Object.assign(this, json);
        this.columnData = this.InputLine.split(/,(?=(?:(?:[^"]*"){2})*[^"]*$)/);
        if (json.Errors) this.Errors = json.Errors.map((json: any) => new MemberUploadLineErrorModel(json));
    }

    public get ErrorsHTML(): string
    {
        return this.Errors.filter(e => e.Error.length > 0).map(e => e.Error).join(', <br/>');
    }

    public ColumnString(columnIndex: number): string { return columnIndex < this.columnData.length ? this.columnData[columnIndex] : ''; }
}

export class MemberUploadResult
{
    ColumnHeaders!: string;
    NumMembersCreated!: number;
    NumMembersUpdated!: boolean;
    UploadErrors: MemberUploadError[] = [];

    constructor(json?: any)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            // Custom mappings
            if (json.UploadErrors) this.UploadErrors = json.UploadErrors.map((json: any) => new MemberUploadError(json));
        }
    }
}

export class CategoryUploadResult
{
    NumCategoriesCreated!: number;
    NumCategoriesDeleted!: boolean;
    NumCategoriesUpdated!: boolean;
    UploadErrors: CategoryUploadError[] = [];

    constructor(json?: any)
    {
        if (json)
        {
            // Map the json object to 'this' objects properties.
            Object.assign(this, json);

            // Custom mappings
            if (json.UploadErrors) this.UploadErrors = json.UploadErrors.map((json: any) => new CategoryUploadError(json));
        }
    }
}

export class CategoryUploadError
{
    LineNumber!: number;
    InputLine!: string;
    Error!: string;

    constructor(json?: any)
    {
        if (json) Object.assign(this, json);
    }
}

export class RecentUploadProgress
{
    CreatedOn!: Date;
    LastUpdated!: Date;
    Description!: string;
    IsRunning = false;
    IsComplete = false;
    Progress!: number;

    constructor(json?: any)
    {
        if (json) Object.assign(this, json);
        this.CreatedOn = AppTeamUtil.getUtcDate(json.CreatedOn)!;
        this.LastUpdated = AppTeamUtil.getUtcDate(json.LastUpdated)!;
    }
}
